<template>
    <div
        class="search-toggle-icon"
        @click="$emit('click', $event)"
    >
        <img :src="iconUrl" alt="">
    </div>
</template>

<script>
export default {
    name: "SearchToggleIcon",
    inject: ['themeUri'],
    emits: ['click'],
    computed: {
        iconUrl(){
            return this.themeUri + '/assets/localdata/_default/search_icon.svg';
        }
    }
}
</script>

<style scoped>
    .search-toggle-icon {
        display: inline-block;
        line-height: 0;
        cursor: pointer;
    }
</style>